// core
import React, {useEffect, useState} from 'react'


// components
// assets
import styles from './Header.module.scss'
import logo_loggedIn from '../../icons/logo_big.png'
import logo_about from '../../icons/logo_about.png'
import {NavLink} from "react-router-dom";


export const Header = () => {



        const [activeMobile, setActiveMobile] = useState(false);
        const [windowParam, setWindowParam] = useState(null);
        const showMenu = () => {
            setActiveMobile(!activeMobile);
        };
        useEffect(() => {
            setWindowParam(window);
        }, [])

        return (
            windowParam &&
            <div className={` ${window.location.pathname.includes('about') ? styles.aboutNav :styles.header}`}>
                <div className={styles.headerInner}>

                    <a className={`${styles.navLogo}`} href="/">

                        {window.location.pathname.includes('about') ?
                            <img className={styles.navLogo} src={logo_about} alt={"Logo"}/>
                            : <img className={styles.navLogo} src={logo_loggedIn} alt={"Logo"}/>}
                    </a>
                    <nav className={`${styles.nav} ${activeMobile ? styles.active : ''}`}>
                        <div className={styles.links}>
                            <NavLink style={window.location.pathname === '/' ? {color: '#006BFF'} : {}} to="/">
                                Home
                            </NavLink>
                            <NavLink style={window.location.pathname === '/products' ? {color: '#006BFF'} : {}}  to="/products">
                                Products
                            </NavLink>
                            <NavLink style={window.location.pathname === '/services' ? {color: '#006BFF'} : {}}  to="/services">
                                Services
                            </NavLink>
                            <NavLink style={window.location.pathname === '/about' ? {color: '#006BFF'} : {}}
                                     to="/about">
                                About
                            </NavLink>
                            <NavLink style={window.location.pathname === '/contactus' ? {color: '#006BFF'} : {}}
                                     to="/contactus">
                                Contact Us
                            </NavLink>
                        </div>

                    </nav>
                    <button onClick={() => window.location.pathname = "contactus"} className={styles.login}>Lets get
                        started
                    </button>
                    <button
                        type="button"
                        className={activeMobile ? `${styles.burgerMenu}  ${styles.active}` : `${styles.burgerMenu}`}
                        onClick={() => showMenu()}>
                        <span className={styles.burgerMenuLines}/>
                    </button>
                </div>
            </div>
        )
    }
;
